import { useEffect, useRef, memo } from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { WithLoadingSpinner } from "@rentablo/components";
import { NoDataStub } from "@rentablo/components";
import { BarChartItem } from "../types";
import { useChartOptions } from "./useChartOptions";

type Props = {
  chartData?: BarChartItem[];
  height?: number;
  color?: string;
  isLoading?: boolean;
  onBarClick?: (value: string) => void;
  selectedBar?: string;
  noDataMessage?: string;
  type: "cost" | "performance";
};

export const BarChart = memo(
  ({
    chartData,
    height = 340,
    color,
    isLoading,
    onBarClick,
    selectedBar,
    noDataMessage,
    type,
  }: Props) => {
    const chartComponentRef = useRef<HighchartsReact.RefObject>(null);

    const chartOptions = useChartOptions(
      height,
      chartData,
      color,
      onBarClick,
      selectedBar,
      type
    );

    useEffect(() => {
      if (!chartComponentRef.current?.chart?.series[0]?.finishedAnimating)
        return;
      chartComponentRef.current.chart.reflow();
    }, [chartOptions]);

    return (
      <WithLoadingSpinner
        isLoading={Boolean(isLoading)}
        style={{ height: height }}
      >
        {!chartData?.length && !isLoading ? (
          <NoDataStub height="300px" secondLine={noDataMessage} />
        ) : (
          !isLoading && (
            <HighchartsReact
              highcharts={Highcharts}
              ref={chartComponentRef}
              options={chartOptions}
              isLoading={Boolean(isLoading)}
            />
          )
        )}
      </WithLoadingSpinner>
    );
  }
);
